module.exports = __webpack_public_path__ + "static/media/app-image.42493ccf.png";